<app-control-layout 
    [control]="formCtrl"
    [label]="label"
    [ignoreLabel]="ignoreLabel"
    [labelBlock]="labelBlock"
    [labelOpacity]="labelOpacity"
    [width]="width"
    [maxLength]="maxLength"
    [attr.id] ="idName">
    <input type ="number" class="form-control text-box" min="{{min}}" *ngIf="!appendWith"
        [formControl]="formCtrl"
        [attr.disabled]="disabled"
        [placeholder]="placeHolder"
        [attr.id] = "idName" 
        [style.width]="labelBlock ? 'calc(100% - 140px)' : width"
        [ngClass]="{'border-danger' : control?.errors?.required && (control?.touched || externalTrigger)}"
        [maxLength]="maxLength"/>

    <!-- if an appendWith value (string) has been passed from the parent its used to both switch on & populate the input-group-append span below -->
    <div class="input-group append-container" *ngIf="appendWith"
        [style.width]="labelBlock ? 'calc(100% - 140px)' : width">
        <input type="number" class="form-control text-box" min="{{min}}" aria-describedby="basic-addon1"
            [formControl]="formCtrl"
            [attr.disabled]="disabled"
            [placeholder]="placeHolder"
            [attr.id] = "idName" 
            [maxLength]="maxLength"/>
        <div class="input-group-append">
            <span class="input-group-text" id="basic-addon1">{{ appendWith}}</span>
        </div>
    </div>
</app-control-layout>